import React, { useState } from 'react';
import './Dashboard.css';
import QuoteRequest from './QuoteRequest';
import CallHistory from './CallHistory';

const Dashboard = ({ userConfig }) => {
  const [activeTab, setActiveTab] = useState('quote');
  const [callHistory, setCallHistory] = useState([]);

  const addToCallHistory = (callRecord) => {
    setCallHistory(prev => [callRecord, ...prev]);
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Welcome, {userConfig.name}</h2>
        <p>Your AI assistant is ready to make calls on your behalf</p>
      </div>
      
      <div className="tab-navigation">
        <button
          className={`tab ${activeTab === 'quote' ? 'active' : ''}`}
          onClick={() => setActiveTab('quote')}
        >
          Get Quotes
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Call History
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'quote' && (
          <QuoteRequest 
            userConfig={userConfig}
            onCallComplete={addToCallHistory}
          />
        )}
        {activeTab === 'history' && (
          <CallHistory 
            callHistory={callHistory}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;